{
  "personalizedDestinations": {
    "title": "Destinations you might like"
  }
}
